import React, { useState, useEffect } from 'react';

const AdminEvents = () => {
  const [selectedPage, setSelectedPage] = useState('events');
  const [actionType, setActionType] = useState('add');
  const [title, setTitle] = useState('');
  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [passkey, setPasskey] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [liveEvents, setLiveEvents] = useState([]);

  // Server se current active events load karna
  const fetchLiveEvents = async () => {
    try {
      const res = await fetch(`/data_${selectedPage}.json?t=${Date.now()}`);
      if (res.ok) {
        const data = await res.json();
        setLiveEvents(Array.isArray(data) ? data : []);
      }
    } catch (err) {
      console.log('Error fetching live events:', err);
    }
  };

  useEffect(() => {
    fetchLiveEvents();
  }, [selectedPage]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setImages((prev) => [...prev, ...files]);
    setPreviews((prev) => [...prev, ...files.map((file) => URL.createObjectURL(file))]);
  };

  const removePhoto = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
    setPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  // Naya Event Upload karna
  const handlePublish = async (e) => {
    e.preventDefault();

    if (passkey.trim() !== '8504999793') {
      alert('Admin Passkey galat hai!');
      return;
    }
    if (!title.trim()) {
      alert('Title bharein!');
      return;
    }
    if (images.length === 0) {
      alert('Kam se kam 1 photo select karein!');
      return;
    }

    setLoading(true);
    setMsg('Photos WebP me convert aur Cloudflare R2 par upload ho rahi hain...');

    const formData = new FormData();
    formData.append('page', selectedPage);
    formData.append('actionType', actionType);
    formData.append('title', title.trim());
    images.forEach((img) => formData.append('images[]', img));

    try {
      const res = await fetch('/upload-event.php', { method: 'POST', body: formData });
      const data = await res.json();
      if (data.success) {
        alert(data.message);
        setTitle('');
        setImages([]);
        setPreviews([]);
        setMsg('');
        fetchLiveEvents();
      } else {
        alert('Upload Error: ' + data.message);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Event ko JSON aur Cloudflare R2 dono se Delete karna
  const handleDeleteEvent = async (id, eventTitle) => {
    const keyPrompt = prompt(`"${eventTitle}" ko delete karne ke liye Admin Passkey dalein:`);
    if (!keyPrompt) return;

    if (keyPrompt.trim() !== '8504999793') {
      alert('Passkey galat hai!');
      return;
    }

    if (!window.confirm(`Kya aap sach me "${eventTitle}" aur uski Cloudflare R2 photos ko hamesha ke liye delete karna chahte hain?`)) {
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('action', 'delete');
    formData.append('id', id);
    formData.append('page', selectedPage);
    formData.append('passkey', keyPrompt.trim());

    try {
      const res = await fetch('/upload-event.php', { method: 'POST', body: formData });
      const data = await res.json();
      if (data.success) {
        alert(data.message);
        setLiveEvents(data.events || []);
      } else {
        alert('Delete Error: ' + data.message);
      }
    } catch (err) {
      alert('Network Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '900px', margin: '40px auto', padding: '30px', background: '#fff', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', fontFamily: 'sans-serif' }}>
      <h2 style={{ textAlign: 'center', color: '#681320', marginBottom: '25px', fontWeight: '700' }}>
        Event Management Dashboard
      </h2>

      {/* Upload Form */}
      <form onSubmit={handlePublish}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px' }}>Select Page / Section:</label>
          <select value={selectedPage} onChange={(e) => setSelectedPage(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}>
            <option value="events">Events Gallery (/events)</option>
          </select>
        </div>

        <div style={{ marginBottom: '20px', padding: '15px', background: '#fdf7f7', borderRadius: '8px', border: '1px solid #f2dede' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '10px', color: '#681320' }}>Choose Action:</label>
          <div style={{ display: 'flex', gap: '30px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input type="radio" name="action" checked={actionType === 'add'} onChange={() => setActionType('add')} />
              <strong>Add New Event</strong>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input type="radio" name="action" checked={actionType === 'replace'} onChange={() => setActionType('replace')} />
              <strong>Replace Old Photos</strong>
            </label>
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px' }}>Event Heading / Title:</label>
          <input type="text" placeholder="e.g. Annual Sports Meet 2026" value={title} onChange={(e) => setTitle(e.target.value)} required style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <div style={{ border: '2px dashed #681320', borderRadius: '10px', padding: '30px', textAlign: 'center', background: '#fafafa', position: 'relative' }}>
            <input type="file" multiple accept="image/*" onChange={handleImageChange} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }} />
            <div style={{ fontSize: '36px', marginBottom: '8px' }}>📁</div>
            <p style={{ margin: 0, fontWeight: '700', color: '#681320' }}>Drag & Drop photos here or Click to Browse</p>
            <small style={{ color: '#777' }}>PNG, JPG, JPEG (Client-Side Auto WebP to R2)</small>
            {images.length > 0 && <p style={{ marginTop: '10px', color: '#27ae60', fontWeight: '600' }}>{images.length} photos selected</p>}
          </div>
        </div>

        {previews.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px' }}>Selected Previews:</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {previews.map((src, index) => (
                <div key={index} style={{ position: 'relative', width: '80px', height: '80px' }}>
                  <img src={src} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '6px' }} />
                  <button type="button" onClick={() => removePhoto(index)} style={{ position: 'absolute', top: '-6px', right: '-6px', background: '#333', color: '#fff', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', fontSize: '12px' }}>×</button>
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={{ marginBottom: '25px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px' }}>Admin Secret Key:</label>
          <input type="password" placeholder="Passkey daalein" value={passkey} onChange={(e) => setPasskey(e.target.value)} required style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
        </div>

        <button type="submit" disabled={loading} style={{ width: '100%', padding: '14px', background: loading ? '#888' : '#681320', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer' }}>
          {loading ? 'Processing...' : '+ Add New Event & Publish'}
        </button>
        {msg && <p style={{ textAlign: 'center', marginTop: '15px', color: '#681320', fontWeight: '600' }}>{msg}</p>}
      </form>

      {/* --- LIVE ACTIVE EVENTS LIST & DELETE SECTION --- */}
      <div style={{ marginTop: '50px', borderTop: '2px solid #eee', paddingTop: '30px' }}>
        <h3 style={{ color: '#681320', marginBottom: '15px' }}>Manage Live Events ({liveEvents.length})</h3>
        {liveEvents.length === 0 ? (
          <p style={{ color: '#888' }}>Abhi koi dynamic event nahi hai.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {liveEvents.map((ev) => (
              <div key={ev.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 18px', background: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                <div>
                  <strong style={{ fontSize: '16px', color: '#333' }}>{ev.title}</strong>
                  <div style={{ fontSize: '13px', color: '#777', marginTop: '4px' }}>
                    {ev.images?.length || 0} Photos | {ev.createdAt || 'N/A'}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => handleDeleteEvent(ev.id, ev.title)}
                  disabled={loading}
                  style={{ background: '#d9534f', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}
                >
                  Delete Event
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminEvents;